module.exports = __webpack_public_path__ + "static/media/cgc-logo.4abbf856.png";